import React from 'react'
import { shouldShowBookingIn, getBookingButtonText } from '../config/booking';

const Hero = () => {
  return (
    <section id="home" className="relative bg-gradient-to-br from-green-50 to-brown-50 py-20 overflow-hidden">
      {/* Background decoration */}
      <div className="absolute inset-0 bg-gradient-to-br from-green-100/20 to-brown-100/20"></div>
      <div className="absolute top-0 right-0 w-96 h-96 bg-green-200 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-pulse"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-brown-200 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-pulse"></div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <div className="animate-fadeIn">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 leading-tight">
              Experience
              <span className="text-green-600"> Natural Healing</span>
              <br />
              with
              <span className="text-brown-600"> Ayurveda</span>
            </h1>
            <p className="mt-6 text-xl text-gray-600 leading-relaxed">
              Discover the ancient wisdom of Ayurvedic medicine combined with modern wellness practices. 
              Our holistic approach focuses on balancing your mind, body, and spirit for optimal health.
            </p>
            <div className="mt-8 flex flex-col sm:flex-row gap-4">
              {shouldShowBookingIn('Hero') && (
                <a
                  href="#contact"
                  className="bg-gradient-green text-white px-8 py-4 rounded-full font-semibold text-lg hover:bg-green-700 transition-all duration-200 shadow-lg hover:shadow-xl text-center"
                >
                  {getBookingButtonText('secondary')}
                </a>
              )}
              <a
                href="#services"
                className="border-2 border-brown-600 text-brown-600 px-8 py-4 rounded-full font-semibold text-lg hover:bg-brown-600 hover:text-white transition-all duration-200 text-center"
              >
                Our Services
              </a>
            </div>
            
            {/* Stats */}
            <div className="mt-12 grid grid-cols-3 gap-8">
              <div className="text-center">
                <div className="text-3xl font-bold text-green-600">500+</div>
                <div className="text-gray-600">Happy Patients</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-brown-600">15+</div>
                <div className="text-gray-600">Years Experience</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-green-600">100%</div>
                <div className="text-gray-600">Natural Remedies</div>
              </div>
            </div>
          </div>

          {/* Hero Image */}
          <div className="animate-slideIn">
            <div className="relative">
              <div className="bg-gradient-to-br from-green-200 to-brown-200 rounded-3xl p-8 shadow-2xl">
                <img
                  src="https://images.unsplash.com/photo-1544161515-4ab6ce6db874?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80"
                  alt="Ayurvedic herbs and treatments"
                  className="w-full h-96 object-cover rounded-2xl shadow-lg"
                />
              </div>
              
              {/* Floating cards */}
              <div className="absolute -top-4 -left-4 bg-white p-4 rounded-xl shadow-lg">
                <div className="flex items-center space-x-2">
                  <div className="w-3 h-3 bg-green-500 rounded-full"></div>
                  <span className="text-sm font-medium">100% Natural</span>
                </div>
              </div>
              
              <div className="absolute -bottom-4 -right-4 bg-white p-4 rounded-xl shadow-lg">
                <div className="flex items-center space-x-2">
                  <div className="w-3 h-3 bg-brown-500 rounded-full"></div>
                  <span className="text-sm font-medium">Ancient Wisdom</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Hero
